import React, { useEffect, useRef, useState } from "react";
import "./contato.css";
import fotoLilia from "../../assets/lilia-mirelly-2.png";
import vectorWave from "../../assets/Vector.png";
import { FaChevronDown } from "react-icons/fa";

export default function Contato() {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const [formData, setFormData] = useState({
    nome: "",
    whatsapp: "",
    segmento: "",
    desafio: "",
  });
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    if (errors[name]) {
      setErrors({ ...errors, [name]: "" });
    }
  };

  const handleBlur = (e) => {
    const { name } = e.target;
    setTouched({ ...touched, [name]: true });
    validateField(name, formData[name]);
  };

  const validateField = (fieldName, fieldValue) => {
    let errorMessage = "";

    switch (fieldName) {
      case "nome":
        if (!fieldValue.trim()) {
          errorMessage = "Nome é obrigatório";
        } else if (fieldValue.trim().length < 3) {
          errorMessage = "Nome deve ter pelo menos 3 caracteres";
        }
        break;

      case "whatsapp":
        if (!fieldValue.trim()) {
          errorMessage = "WhatsApp é obrigatório";
        } else {
          const numbers = fieldValue.replace(/\D/g, "");
          if (numbers.length < 10 || numbers.length > 11) {
            errorMessage = "WhatsApp deve ter 10 ou 11 dígitos";
          }
        }
        break;

      case "desafio":
        if (!fieldValue.trim()) {
          errorMessage = "Desafio é obrigatório";
        }
        break;

      default:
        break;
    }

    setErrors((prev) => ({ ...prev, [fieldName]: errorMessage }));
    return !errorMessage;
  };

  const validateForm = () => {
    const fieldsToValidate = ["nome", "whatsapp", "desafio"];
    let isValid = true;

    fieldsToValidate.forEach((field) => {
      const fieldValid = validateField(field, formData[field]);
      if (!fieldValid) isValid = false;
    });

    const allTouched = {};
    fieldsToValidate.forEach((field) => {
      allTouched[field] = true;
    });
    setTouched(allTouched);

    return isValid;
  };

  const openWhatsAppWithMessage = () => {
    if (!validateForm()) {
      return;
    }

    const message = `*NOVO PEDIDO DE DIAGNÓSTICO - CONECTA LM*%0A%0A
*Nome:* ${formData.nome}%0A
*WhatsApp:* ${formData.whatsapp}%0A
*Segmento:* ${formData.segmento || "Não informado"}%0A
*Desafio:* ${formData.desafio}%0A
*Valor:* R$97`;

    window.open(`https://wa.me/5598986064394?text=${message}`, "_blank");
  };

  const formatWhatsApp = (value) => {
    const numbers = value.replace(/\D/g, "");

    if (numbers.length <= 10) {
      return numbers.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
    } else {
      return numbers.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
    }
  };

  const handleWhatsAppChange = (e) => {
    const { value } = e.target;
    const formattedValue = formatWhatsApp(value);
    setFormData({ ...formData, whatsapp: formattedValue });
    if (errors.whatsapp) {
      setErrors({ ...errors, whatsapp: "" });
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.1 },
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  // Opções para o select de segmento
  const opcoesSegmento = [
    "Moda e Vestuário",
    "Alimentação e Gastronomia",
    "Serviços (consultoria, estética, etc.)",
    "Tecnologia e Software",
    "Educação e Cursos",
    "Saúde e Bem-estar",
    "Outro",
  ];

  // Opções para o select de desafio
  const opcoesDesafio = [
    "Não estou vendendo o suficiente",
    "Meu site ou redes sociais não convertem",
    "Não sei por onde começar a organizar minha presença digital",
    "Quero uma visão geral e honesta do meu negócio",
  ];

  return (
    <section id="contato" className="contato-compacto-section" ref={sectionRef}>
      <div className="titulo-topo-reto">
        <h2>
          DESCUBRA O QUE ESTÁ <span className="destaque-rosa">TRAVANDO</span>{" "}
          SUAS VENDAS
        </h2>

        <p className="texto-motivacional">
          Um diagnóstico completo do seu negócio digital, com plano de ação
          prático por R$97.
        </p>
      </div>

      <div className="contato-container-grid">
        <div className={`contato-imagem-box ${isVisible ? "animate-up" : ""}`}>
          <img
            src={fotoLilia}
            alt="Lilia e Mirelly"
            className="foto-lilia-contato"
          />
        </div>

        <div className={`contato-form-box ${isVisible ? "animate-right" : ""}`}>
          <form className="form-corpo" onSubmit={(e) => e.preventDefault()}>
            <div className="frase-conversao">
              <p className="frase-destaque">
                <strong>Diagnóstico Completo por R$97</strong> um raio-x do seu
                momento digital, com plano de ação personalizado e prioridades
                claras para vender mais.
              </p>
            </div>

            {/* Campo 1: Nome - OBRIGATÓRIO */}
            <div className="campo-form">
              <label htmlFor="nome">
                Nome / Nome da empresa <span className="required">*</span>
              </label>
              <input
                type="text"
                id="nome"
                name="nome"
                placeholder="Ex: João Silva ou Empresa XYZ"
                value={formData.nome}
                onChange={handleInputChange}
                onBlur={handleBlur}
                className={touched.nome && errors.nome ? "error" : ""}
                required
              />
              {touched.nome && errors.nome && (
                <span className="error-message">{errors.nome}</span>
              )}
            </div>

            {/* Campo 2: WhatsApp - OBRIGATÓRIO */}
            <div className="campo-form">
              <label htmlFor="whatsapp">
                WhatsApp <span className="required">*</span>
              </label>
              <input
                type="tel"
                id="whatsapp"
                name="whatsapp"
                placeholder="(99) 99999-9999"
                value={formData.whatsapp}
                onChange={handleWhatsAppChange}
                onBlur={handleBlur}
                className={touched.whatsapp && errors.whatsapp ? "error" : ""}
                required
              />
              {touched.whatsapp && errors.whatsapp && (
                <span className="error-message">{errors.whatsapp}</span>
              )}
            </div>

            {/* Campo 3: Segmento - SELECT com opções - OPCIONAL */}
            <div className="campo-form">
              <label htmlFor="segmento">
                Qual o segmento do seu negócio?{" "}
                <span className="opcional">(opcional)</span>
              </label>
              <select
                id="segmento"
                name="segmento"
                value={formData.segmento}
                onChange={handleInputChange}
              >
                <option value="">Selecione uma opção</option>
                {opcoesSegmento.map((opcao) => (
                  <option key={opcao} value={opcao}>
                    {opcao}
                  </option>
                ))}
              </select>
            </div>

            {/* Campo 4: Desafio - SELECT com opções - OBRIGATÓRIO */}
            <div className="campo-form mensagem">
              <label htmlFor="desafio">
                Qual seu maior desafio hoje? <span className="required">*</span>
              </label>
              <select
                id="desafio"
                name="desafio"
                value={formData.desafio}
                onChange={handleInputChange}
                onBlur={handleBlur}
                className={touched.desafio && errors.desafio ? "error" : ""}
                required
              >
                <option value="">Selecione uma opção</option>
                {opcoesDesafio.map((opcao) => (
                  <option key={opcao} value={opcao}>
                    {opcao}
                  </option>
                ))}
              </select>
              {touched.desafio && errors.desafio && (
                <span className="error-message">{errors.desafio}</span>
              )}
            </div>

            {/* Botão de envio */}
            <button
              type="button"
              className="btn-enviar-contato"
              onClick={openWhatsAppWithMessage}
            >
              QUERO MEU DIAGNÓSTICO POR R$97
              <span className="btn-icon">
                <FaChevronDown className="icon-pulse" />
              </span>
            </button>

            {/* Texto de segurança */}
            <span className="secure-text">
              🔒 Seus dados estão seguros. Não enviamos spam. Você recebe
              retorno em até 48h a 72h pelo WhatsApp.
            </span>
          </form>
        </div>
      </div>

      <img src={vectorWave} alt="Wave" className="onda-background" />
    </section>
  );
}
